<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="blue" title="Hasil Test" text="Gambaran Karakter dari pelamar">
          <v-card-title>
            <v-toolbar flat color="white">
              <v-spacer />
              <!-- DATE PICKER MODEL 1 -->
              <v-flex xs12 sm6 md4>
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="date"
                    label="Cari tanggal test"
                    prepend-icon="event"
                    readonly
                    clearable
                  />
                  <v-date-picker
                    v-model="date"
                    locale="id"
                    dark
                    color="light-blue darken-2"
                    header-color="light-blue darken-2"
                    scrollable
                  >
                    <v-spacer />
                    <v-btn fab round color="light-blue darken-4" @click="modal = false">Batal</v-btn>
                    <v-btn fab round color="light-blue darken-4" @click="$refs.dialog.save(date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
            </v-toolbar>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="results"
            :search="date"
            class="elevation-1"
            sort-icon="mdi-menu-down"
          >
            <template slot="headerCell" slot-scope="{header}">
              <span
                slot="activator"
                class="subheading text-info text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{item}">
              <td class="font-weight-regular">{{ item.applicant ? item.applicant.name : '-'}}</td>
              <td class="font-weight-regular">{{ item.test_date | dateFormat }}</td>
              <td class="font-weight-regular">
                <span v-if="item.least != 0">{{ item.core_private.disc_type }}</span>

                <span v-else style="font-size:12px !important" class="text-warning font-italic">
                  <v-icon class="text-warning" small>mdi-alert-circle-outline</v-icon>&nbsp;
                  silahkan liat grafik
                </span>
              </td>
              <td class="font-weight-regular">
                <span v-if="item.most != 0">{{ item.mask_public.disc_type }}</span>

                <span v-else style="font-size:12px !important" class="text-warning font-italic">
                  <v-icon class="text-warning" small>mdi-alert-circle-outline</v-icon>&nbsp;
                  silahkan liat grafik
                </span>
              </td>
              <td class="font-weight-regular">
                <span v-if="item.change != 0">{{ item.mirror_perceived.disc_type }}</span>

                <span v-else style="font-size:12px !important" class="text-warning font-italic">
                  <v-icon class="text-warning" small>mdi-alert-circle-outline</v-icon>&nbsp;
                  silahkan liat grafik
                </span>
              </td>
              <td class="font-weight-regular">{{ item.user.name }}</td>
              <td class="justify-right">
                <v-flex xs8 sm8>
                  <v-btn
                    v-tooltip.top-center="{content: 'tampilkan hasil test'}"
                    slot="activator"
                    :disabled="item.result === null"
                    :to="'/detail/'+item.applicant_id"
                    small
                    color="indigo accent-3"
                  >Hasil test</v-btn>
                </v-flex>
              </td>
            </template>

            <template slot="no-data">
              <v-progress-circular :size="50" :width="3" color="blue" indeterminate />
            </template>

            <!-- <template slot="no-results">
              <v-alert :value="true" color="error" icon="warning">Maap, data masih kosong :(</v-alert>
            </template>-->

            <v-alert
              slot="no-results"
              :value="true"
              color="red"
              icon="warning"
            >Pencarian "{{ date }}" tidak ditemukan</v-alert>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="stylus" scoped>
.v-progress-circular {
  margin: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>

<script>
export default {
  filters: {
    dateFormat(date) {
      let newDate = new Date(date);

      let dd = newDate.getDate();
      let mm = newDate.getMonth() + 1;
      let yyyy = newDate.getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      let newFormat = dd + "-" + mm + "-" + yyyy;

      return newFormat;
    },

    capitalizeText(text) {
      return text.charAt(0).toUpperCase() + text.substring(1);
    }
  },
  data() {
    return {
      headers: [
        {
          // sortable: false,
          text: "Nama",
          value: "applicant"
        },
        {
          // sortable: false,
          text: "Tanggal Test",
          value: "test_date"
        },
        {
          // sortable: false,
          text: "Core Private",
          value: "least"
        },
        {
          // sortable: false,
          text: "Mask Public",
          value: "most"
        },
        {
          //   sortable: false,
          text: "Mirror Perceived",
          value: "change"
        },
        {
          text: "PIC",
          value: "user"
        },
        {
          text: "action"
        }
      ],

      results: [],
      dialog: false,
      date: "",
      modal: false,
      definition: null
    };
  },

  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    let url = "/results";

    this.axios
      .get(url)
      .then(response => {
        let data = response.data.data;
        this.results = data;
        console.log(this.results)
      })
      .catch(error => {
        console.log(error.response);
      });
  },

  methods: {
    showDetail() {
      this.$router.push("/detail");
    }
  }
};
</script>
